import { useState, useEffect } from 'react'
import { marketingApi } from '../api/marketing'
import Boton from '../components/Boton'

const EMPTY = { nombre: '', asunto: '', preheader: '', cuerpo_html: '' }

export default function MktPlantillasPage() {
  const [plantillas, setPlantillas] = useState([])
  const [sel, setSel] = useState(null)      // id seleccionada | 'new'
  const [form, setForm] = useState(EMPTY)
  const [tab, setTab] = useState('editar')
  const [msg, setMsg] = useState('')
  const [testEmail, setTestEmail] = useState('')
  const [saving, setSaving] = useState(false)

  const cargar = () => marketingApi.plantillas().then(r => setPlantillas(r.data))
  useEffect(() => { cargar() }, [])

  const abrir = async (id) => {
    setMsg('')
    if (id === 'new') { setSel('new'); setForm(EMPTY); return }
    const r = await marketingApi.plantilla(id)
    setSel(id)
    setForm({ nombre: r.data.nombre, asunto: r.data.asunto || '', preheader: r.data.preheader || '', cuerpo_html: r.data.cuerpo_html })
  }

  const guardar = async () => {
    setSaving(true); setMsg('')
    try {
      if (sel === 'new') {
        const r = await marketingApi.crearPlantilla(form)
        setSel(r.data.id)
        setMsg('✓ Plantilla creada')
      } else {
        await marketingApi.actualizarPlantilla(sel, form)
        setMsg('✓ Guardada')
      }
      cargar()
    } catch (e) { setMsg(e.response?.data?.message || 'Error al guardar') }
    finally { setSaving(false) }
  }

  const enviarTest = async () => {
    if (!testEmail || sel === 'new') return
    setMsg('')
    try {
      const r = await marketingApi.testPlantilla(sel, testEmail)
      setMsg('✓ ' + r.data.message)
    } catch (e) { setMsg(e.response?.data?.message || 'Error al enviar prueba') }
  }

  const eliminar = async (p) => {
    if (!window.confirm(`¿Eliminar la plantilla "${p.nombre}"?`)) return
    await marketingApi.eliminarPlantilla(p.id)
    if (sel === p.id) { setSel(null); setForm(EMPTY) }
    cargar()
  }

  const previewHtml = (form.cuerpo_html || '<p style="font-family:sans-serif;color:#888;padding:24px">(sin contenido)</p>')
    .replace(/\{\{\s*nombre\s*\}\}/gi, 'Juan Prueba')
    .replace(/\{\{\s*email\s*\}\}/gi, 'prueba@lgr.local')
    .replace(/\{\{\s*unsubscribe_url\s*\}\}/gi, '#')

  return (
    <div>
      <div style={st.head}>
        <h2 style={st.title}>Plantillas de email</h2>
        <div style={{ display: 'flex', gap: 8 }}>
          <Boton variante="send" onClick={async () => {
            const r = await marketingApi.sincronizarPlantillas()
            window.alert(r.data.salida || 'Plantillas sincronizadas')
            cargar()
          }}>⟳ Traer del repo de diseño</Boton>
          <Boton variante="primary" onClick={() => abrir('new')}>+ Nueva</Boton>
        </div>
      </div>

      <div style={st.layout}>
        {/* Lista lateral */}
        <div style={st.lista}>
          {plantillas.map(p => (
            <div key={p.id} style={{ ...st.item, ...(sel === p.id ? st.itemSel : {}) }}>
              <button style={st.itemBtn} onClick={() => abrir(p.id)}>
                <span style={{ fontWeight: 700 }}>{p.nombre}</span>
                {p.asunto && <span style={st.itemSub}>{p.asunto}</span>}
              </button>
              <Boton variante="destructive" sm style={{ border: 'none', alignSelf: 'center', marginRight: 6 }} onClick={() => eliminar(p)} title="Eliminar">✕</Boton>
            </div>
          ))}
          {plantillas.length === 0 && (
            <p style={{ color: '#94a3b8', fontSize: '0.85rem', padding: 8 }}>
              Sin plantillas. Corré <code>marketing:cargar-plantillas-base</code> para traer las de Ligier.
            </p>
          )}
        </div>

        {/* Editor */}
        {sel !== null ? (
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={st.grid}>
              <input style={st.inp} value={form.nombre} onChange={e => setForm(f => ({ ...f, nombre: e.target.value }))} placeholder="Nombre de la plantilla *" />
              <input style={st.inp} value={form.asunto} onChange={e => setForm(f => ({ ...f, asunto: e.target.value }))} placeholder="Asunto sugerido" />
            </div>
            <div style={st.tabs}>
              <button onClick={() => setTab('editar')} style={{ ...st.tabBtn, ...(tab === 'editar' ? st.tabOn : {}) }}>✏️ HTML</button>
              <button onClick={() => setTab('preview')} style={{ ...st.tabBtn, ...(tab === 'preview' ? st.tabOn : {}) }}>👁 Preview</button>
              <span style={st.vars}>{'{{ nombre }} · {{ email }} · {{ unsubscribe_url }}'}</span>
            </div>
            {tab === 'editar'
              ? <textarea style={st.editor} value={form.cuerpo_html} onChange={e => setForm(f => ({ ...f, cuerpo_html: e.target.value }))} spellCheck={false} />
              : <iframe title="preview" style={st.preview} srcDoc={previewHtml} />}

            <div style={st.acciones}>
              {msg && <span style={{ fontSize: '0.85rem', color: msg.startsWith('✓') ? '#166534' : '#dc2626' }}>{msg}</span>}
              <input style={{ ...st.inp, maxWidth: 230 }} type="email" placeholder="email para prueba" value={testEmail} onChange={e => setTestEmail(e.target.value)} />
              <Boton variante="send" onClick={enviarTest} disabled={sel === 'new' || !testEmail}>📧 Enviar prueba</Boton>
              <Boton variante="primary" onClick={guardar} disabled={saving || !form.nombre || !form.cuerpo_html}>
                {saving ? 'Guardando…' : 'Guardar'}
              </Boton>
            </div>
          </div>
        ) : (
          <div style={st.vacio}>Elegí una plantilla de la izquierda o creá una nueva.</div>
        )}
      </div>
    </div>
  )
}

const st = {
  head: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 },
  title: { margin: 0, fontSize: '1.4rem', color: '#0f172a' },
  layout: { display: 'flex', gap: 16, alignItems: 'flex-start' },
  lista: { width: 260, flexShrink: 0, display: 'flex', flexDirection: 'column', gap: 6 },
  item: { display: 'flex', background: '#fff', border: '1px solid #e2e8f0', borderRadius: 10, overflow: 'hidden' },
  itemSel: { borderColor: '#1e40af', boxShadow: '0 0 0 1px #1e40af' },
  itemBtn: { flex: 1, textAlign: 'left', padding: '10px 12px', background: 'none', border: 'none', cursor: 'pointer', display: 'flex', flexDirection: 'column', gap: 2, minWidth: 0 },
  itemSub: { fontSize: '0.72rem', color: '#94a3b8', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  grid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 10 },
  inp: { width: '100%', padding: '0.5rem 0.7rem', border: '1px solid #d1d5db', borderRadius: 8, fontSize: '0.9rem', boxSizing: 'border-box' },
  tabs: { display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 },
  tabBtn: { padding: '0.4rem 0.85rem', border: '1px solid #d1d5db', borderRadius: 8, background: '#fff', cursor: 'pointer', fontWeight: 600, fontSize: '0.82rem' },
  tabOn: { background: '#1e40af', color: '#fff', borderColor: '#1e40af' },
  vars: { marginLeft: 'auto', fontSize: '0.72rem', color: '#94a3b8', fontFamily: 'monospace' },
  editor: { width: '100%', height: 420, fontFamily: 'monospace', fontSize: '0.8rem', padding: 12, border: '1px solid #d1d5db', borderRadius: 10, boxSizing: 'border-box', resize: 'vertical' },
  preview: { width: '100%', height: 420, border: '1px solid #d1d5db', borderRadius: 10, background: '#fff' },
  acciones: { display: 'flex', alignItems: 'center', gap: 10, marginTop: 10, justifyContent: 'flex-end' },
  vacio: { flex: 1, padding: 60, textAlign: 'center', color: '#94a3b8', background: '#fff', border: '1px dashed #e2e8f0', borderRadius: 12 },
}
